import { ICruise } from "../slices/searchSlice";
import { store } from "../store";

import { searchApi } from "./apiSingleton";

export interface ILocation {
  type: "ship" | "country" | "cruise_tag";
  name: string;
  value: string;
}

type ISearchResultsResponse = ICruise[] | undefined;

export interface ISearchResultsRequest {
  search: string;
  language: string;
}

interface ICruiseRequest {
  cruiseId: string;
  source: string;
  language: string;
  residency?: string;
}

interface ISearchLocationsResponse {
  last_date: string;
  auto_complete_items: Array<Record<string, string>>;
}

export const SearchAPI = searchApi.injectEndpoints({
  endpoints: (builder) => ({
    initSearchResults: builder.query<
      ISearchResultsResponse,
      ISearchResultsRequest
    >({
      query: ({ search, language }) => {
        const { sessionKey } = store.getState().session;

        return {
          url: `/search/${search}&session=${sessionKey ?? ""}&language=${language}`,
          method: "GET",
        };
      },
    }),

    initCruise: builder.query<ICruise, ICruiseRequest>({
      query: ({ cruiseId, source, language, residency }) => {
        const { sessionKey } = store.getState().session;

        return {
          url: `/search/${cruiseId}?session=${
            sessionKey ?? ""
          }&language=${language}&source=${source}${residency && `&residency=${residency}`}`,
        };
      },
    }),

    searchLocations: builder.query<ISearchLocationsResponse, unknown>({
      query: () => {
        const { sessionKey } = store.getState().session;
        const { api_language } = store.getState().environment;

        return {
          url: `/searchform/?session=${sessionKey ?? ""}&language=${api_language}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useLazyInitCruiseQuery, useLazySearchLocationsQuery } =
  SearchAPI;
